import * as React from 'react';
import styles from '../focus-import.module.css';
import { Typography } from '@SBGSports/referee-react';
import { ValidationMessage } from './validation-message';
import { useCallback } from 'react';
import { useTranslations } from 'i18n';
import { FocusFile } from 'shared/file-importer/types';

interface ImportValidationFeedbackProps {
    fileName: string;
    focusFile: FocusFile | undefined;
    isDuplicateFile: boolean;
}
export const ImportValidationFeedback: React.FC<ImportValidationFeedbackProps> = (props) => {
    const { fileName, focusFile, isDuplicateFile } = props;
    const { __ } = useTranslations();

    const validMessage = __('smt_importer.valid_file_selected');
    const errorMessage = __('smt_importer.invalid_file', { productName: 'Focus', fileType: '.JSON' });
    const duplicateImportMessage = __('smt_importer.duplicate_file_selected');

    const getIconType = useCallback((file: FocusFile | undefined, isDuplicate: boolean) => {
        if (!file) {
            return 'error';
        }
        if (isDuplicate) {
            return 'warning';
        }
        return 'success';
    }, []);

    const getDisplayMessage = useCallback(
        (file: FocusFile | undefined, isDuplicate: boolean) => {
            if (!file) {
                return errorMessage;
            }
            if (isDuplicate) {
                return duplicateImportMessage;
            }
            return validMessage;
        },
        [duplicateImportMessage, errorMessage, validMessage],
    );

    return (
        <div className={styles['import-feedback-wrapper']}>
            <ValidationMessage
                iconType={getIconType(focusFile, isDuplicateFile)}
                message={getDisplayMessage(focusFile, isDuplicateFile)}
            />
            <Typography variant="body-1">{fileName}</Typography>
        </div>
    );
};
